import { apiPost } from 'api';
import { AddNoteRequest, AddNoteResponse } from '../../types';

export const addNote = (request: AddNoteRequest): Promise<AddNoteResponse> =>
  apiPost<AddNoteResponse, AddNoteRequest>(
    `consultations/${request.consultationId}/notes`,
    request
  );
